import React from "react";
import "./About.css";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";




function Objective() {
  return (
    <div className="about-page">
      <Header />
      <header className="height-75">
        <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
          <h1 className="text-center fw-semibold">Objective</h1>
        </div>
      </header>

      <div className="container my-5">
        <div className="row">
          <div className="col-lg-6 d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">


            <h4>Objective</h4>

            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>

              <ul>
                <li>To unlock the multiple facets of the students and to facilitate realization of student's potential for excellence.</li>
                <li>To provide them access to a comprehensive array of careers.</li>
                <li>To promote research culture in order to channelize their spirit of inquiry.

                </li>

                <li>To motivate the students for continuous personal and professional growth.</li>

                <li>To instill moral values to mould them into excellent human resource.</li>
                <li>To provide homely environment in the institution.</li>
                <li>To develop students into socially responsible citizens.</li>
                <li>To attain still greater heights of glory and excellence.</li>

              </ul>
            </p>

          </div>
          <div className="col-lg-6 d-flex justify-content-center">
            <img
              src="./img/banner-acm.png"
              className="img-fluid h-100 w-100"
              alt=""
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Objective;
